import React from 'react';
import { Row, Col } from 'antd';
import Book from '../book';
import PropTypes from 'prop-types';

export default class ListRec extends React.Component {
    render() {
        const content = this.props.data.reduce((res, item , idx) => {
            if (idx % this.props.column) {
                res[parseInt(idx / this.props.column, 10)].push(item);
            } else {
                res.push([item]); 
            }
            return res;
        }, []).map((arr, idx) => (
            <Row key={idx} type="flex" justify="space-between" style={{
                marginTop: `${idx ? this.props.gap : 0}px`, 
            }}>
            {arr.map((item, idx2) => (
                <Col key={idx2} style={{width: `${this.props.width}px`}}>            
                    <Book template={this.props.template} {...item} />
                </Col>
            ))}
            </Row>
        ));
        return (
        <div>
            {this.props.header}
            {content}
        </div>
        );
    }
}

ListRec.defaultProps = {
    gap: 0,
    template: 'brief_3',
    data: [],
};

ListRec.protoTypes = {
    column: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    gap: PropTypes.number, //行之间间隔
    header: PropTypes.func,
    template: PropTypes.string,
    data: PropTypes.array,
};




// WEBPACK FOOTER //
// ./src/component/rec/list_rec.js